/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Type } from "class-transformer";
import { SmBaseEntity } from "src/modules/sm-base/shared/sm-base-entity.model";
import { Column, Entity, ManyToOne } from "typeorm";
import { ProductInformation } from "./productInformation.entity";

@Entity()
export class ProductImage extends SmBaseEntity {
    @Column({default: ""})
    filePath: string = "";

    @Column({default: ""})
    fileName: string = "";

    @Column({default: ""})
    wfId: string = "";

    @ManyToOne((_type) => ProductInformation, productInfo => productInfo.additives)
    @Type(() => ProductInformation)
    product: ProductInformation;
}